/* This file contains predefined variables to avoid typo while dispatching*/

const REDIRECT_TO_AGREEMENT_URL = "REDIRECT_TO_AGREEMENT_URL";
const RESET_TO_AGREEMENT_URL = "RESET_TO_AGREEMENT_URL";

export const agreementTypes = {
  REDIRECT_TO_AGREEMENT_URL,
  RESET_TO_AGREEMENT_URL,
};
